/**
 * Created By Elia Rohana on 12/6/18
 */
import PaletteProvider from 'bpmn-js/lib/features/palette/PaletteProvider';
import { ActionItems, Base } from 'diagram-js/lib/model';

export class PathwaysPaletteProvider extends PaletteProvider {


    constructor(private palette, private create, private elementFactory, private spaceTool, private lassoTool, private handTool, private globalConnect, private translate) {
        super(palette, create, elementFactory, spaceTool, lassoTool, handTool, globalConnect, translate);
    }

    getPaletteEntries(element: Base): ActionItems {

        const activateHand = this.activateHand.bind(this);
        const lassoToolActivateSelection = this.lassoToolActivateSelection.bind(this);
        const spaceToolActivateSelection = this.spaceToolActivateSelection.bind(this);
        const actions  = { };
        Object.assign(actions, {
            'hand-tool': {
                group: 'tools',
                className: 'bpmn-icon-hand-tool',
                title: this.translate('Activate the hand tool'),
                action: {
                    click: activateHand
                }
            },
            'lasso-tool': {
                group: 'tools',
                className: 'bpmn-icon-lasso-tool',
                title: this.translate('Activate the lasso tool'),
                action: {
                    click: lassoToolActivateSelection
                }
            },
            'space-tool': {
                group: 'tools',
                className: 'bpmn-icon-space-tool',
                title: this.translate('Activate the create/remove space tool'),
                action: {
                    click: spaceToolActivateSelection
                }
            }
        });
        return actions;

    }

    activateHand(event) {
        this.handTool.activateHand(event);
    }

    lassoToolActivateSelection(event) {
        this.lassoTool.activateSelection(event);
    }

    spaceToolActivateSelection (event) {
        this.spaceTool.activateSelection(event);
    }

}
